export default "__VITE_ASSET__O8FEIugW__"